import React, { useState, Fragment } from 'react';
// import IconButton from '@mui/material/IconButton';
// import AddIcon from '@mui/icons-material/Add';
// import Button from '@mui/material/Button';
import { Button, Form, Modal } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import 'bootstrap/dist/css/bootstrap.min.css';
import Wheel from '@uiw/react-color-wheel';
import { hsvaToHex } from '@uiw/color-convert';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ColorLensOutlinedIcon from '@mui/icons-material/ColorLensOutlined';



const InputComponent = ({ addNewColor }) => {
  const [color, setColor] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [shake, setShake] = useState(false);
  const [hsva, setHsva] = useState({ h: 214, s: 43, v: 90, a: 1 });
  const [showModal, setShowModal] = useState(false);

  const handleModalShow = () => setShowModal(true);

  const handleModalClose = () => {
    setShowModal(false);
  };
  
  const handleButtonModalSelect = () => {
    handleButtonClick();
    setShowModal(false);
  };

  const handleColorChange = (newColor) => {
    setHsva(newColor.hsva);
    const hexColor = hsvaToHex(newColor.hsva);
    setColor(hexColor);
    setIsValid(/^#[0-9A-F]{6}$/i.test(hexColor));
  };

  const onAnimationEnd = () => {
    setShake(false);
  };

  const handleChange = (e) => {
    // setColor(event.target.value);

    let value = e.target.value;

    // Ensure that the value always starts with '#'
    if (!value.startsWith('#')) {
      value = '#' + value;
    }

    // Limit the input to 7 characters (1 for '#' + 6 for the color code)
    if (value.length > 7) {
      value = value.slice(0, 7);
    }

    setColor(value);
  };


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleButtonClick();
    }
    // Prevent input if length exceeds 7 characters
    else if (color.length >= 7 && e.key !== 'Backspace' && e.key !== 'Delete') {
      e.preventDefault();
    }
  };


  const handleButtonClick = () => {
    // Validate hexadecimal color
    let isValidHex = /^#[0-9A-F]{6}$/i.test(color);
    if (isValidHex){
        setIsValid(isValidHex);
    } else {
        isValidHex = /^[0-9A-F]{6}$/i.test(color);
        setIsValid(isValidHex);
    }

    if (!isValidHex){
      setIsValid(false);
      setShake(true);
    }

    if (isValidHex) {
        if (color.includes("#")){
            addNewColor(color);
        } else{
            addNewColor("#" + color);
        }
      // Clear input
      setColor('');
    }
  }; 

  return (
    <>
      <p
        style={{
          textAlign:"center", 
          color:"#575a5e"         
        }}
      >
        Type or select a color
      </p>
    <div style={{
      display: 'flex',
      alignItems: 'center', // Align items vertically at the center
      justifyContent: 'center',
      marginTop: "1%",
      maxHeight:"10vh",
    }}>
      
    <div style={{
      // padding: isValid ? "0.5%" : "0.5%",
      // border: "2px solid #abaeaf",
      // borderRadius: "5px",
      overflowX: 'hidden',
      display: "flex",
      alignItems: "center", // Center vertically
      animation: shake ? "rotate 0.1s linear 10" : "",
      // animation: shake ? "shake 0.1s linear 10" : "",
      transition: "background-color 0.3s ease",
        }} onAnimationEnd={onAnimationEnd}>
          <style>
            {`
            @keyframes rotate {
              0% { transform: rotate(0deg); }
              10% { transform: rotate(-5deg); }
              20% { transform: rotate(5deg); }
              30% { transform: rotate(-5deg); }
              40% { transform: rotate(5deg); }
              50% { transform: rotate(-5deg); }
              60% { transform: rotate(5deg); }
              70% { transform: rotate(-5deg); }
              80% { transform: rotate(5deg); }
              90% { transform: rotate(-5deg); }
              100% { transform: rotate(0deg); }
            }

            @keyframes shake {
              0% { transform: translateX(0); }
              10% { transform: translateX(-5px); }
              20% { transform: translateX(5px); }
              30% { transform: translateX(-5px); }
              40% { transform: translateX(5px); }
              50% { transform: translateX(-5px); }
              60% { transform: translateX(5px); }
              70% { transform: translateX(-5px); }
              80% { transform: translateX(5px); }
              90% { transform: translateX(-5px); }
              100% { transform: translateX(0); }
            }
            `}
          </style>
          
          <InputGroup className="mb-3">
            <Button variant="outline-secondary" onClick={handleModalShow}
              style={{
                // backgroundColor:"#098897"
                // backgroundColor: isValid ? "rgba(208, 214, 217, 0.7)" : "rgba(255, 0, 0, 0.21)"
                backgroundColor: isValid ? "" : "rgba(255, 0, 0, 0.21)"
              }}
            >
              <ColorLensIcon/>
            </Button>
            <Form.Control
              placeholder="#FFF000"
              className="bg-body-tertiary"
              // error={!isValid}
              value={color}
              onChange={handleChange}
              onKeyDown={handleKeyPress}
              style={{
                backgroundColor: isValid ? "" : "rgba(255, 0, 0, 0.21)" ,
              }}
              />
            {/* <Form.Control/> */}
            <Button variant="outline-secondary" onClick={handleButtonClick} id="button-addon2"
            style={{
              // backgroundColor: isValid ? "rgba(208, 214, 217, 0.7)" : "rgba(255, 0, 0, 0.21)"
              backgroundColor: isValid ? "" : "rgba(255, 0, 0, 0.21)"
            }}>
              Add 
            </Button>
          </InputGroup>
    </div>
    </div>
      <p 
      style={{
        animation: shake ? "rotate 0.1s linear 10" : "",
        textAlign:"center",
        padding:"0",
        top:"0",
        fontSize:"85%",
        color:"rgba(255, 0, 0, 40)",
        overflowX: 'hidden',
      }}>
        {!isValid ? 'Example: #F0F0F0':" "}
      </p>

      <Modal show={showModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Color</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Wheel color={hsva} onChange={handleColorChange} />
          <div style={{ width: '100%', height: 34, marginTop: 20, background: hsvaToHex(hsva) }}></div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={handleButtonModalSelect}>
            Select !
          </Button>
        </Modal.Footer>
      </Modal>
    </>
    
  );



};

export default InputComponent;